export const getUser = () => {
  const dataStr = sessionStorage.getItem("data");
  if (dataStr) return JSON.parse(dataStr);
  else return null;
};

export const getToken = () => {
  return sessionStorage.getItem("token") || null;
};

export const setUserSession = (token, data) => {
  sessionStorage.setItem("token", token);
  if ( data !== null ) {
    sessionStorage.setItem("data", JSON.stringify(data));
    const osnovniPodaci = JSON.parse(data);
    sessionStorage.setItem("osnovniPodaci", JSON.stringify(osnovniPodaci));
    sessionStorage.setItem("ustanova", osnovniPodaci.ustanova);
    sessionStorage.setItem("nazivUstanove", osnovniPodaci.naziv_ustanove);
    sessionStorage.setItem("polaznik", osnovniPodaci.polaznik);
    sessionStorage.setItem("maticniBroj", osnovniPodaci.maticni_broj);
    sessionStorage.setItem("premaObliku", osnovniPodaci.prema_obliku);
    sessionStorage.setItem("godinaUpisa", osnovniPodaci.godina_upisa);
    sessionStorage.setItem("redniBroj", osnovniPodaci.redni_broj);
    sessionStorage.setItem("biljeskaPolaznika",osnovniPodaci.biljeska_polaznika);
    sessionStorage.setItem("biljeskePrveGodine", osnovniPodaci.biljeske_prve_godine);
    sessionStorage.setItem("biljeskeDrugeGodine", osnovniPodaci.biljeske_druge_godine);
    sessionStorage.setItem("biljeskeTreceGodine", osnovniPodaci.biljeske_trece_godine);
    sessionStorage.setItem("biljeskeCetvrteGodine", osnovniPodaci.biljeske_cetvrte_godine);
    sessionStorage.setItem("tekuciRazred", osnovniPodaci.tekuci_razred);
    sessionStorage.setItem("razredPregleda", osnovniPodaci.tekuci_razred);
  } else {
    sessionStorage.setItem("data", "Nema podataka");
    sessionStorage.setItem("osnovniPodaci", "Nema podataka");
    sessionStorage.setItem("ustanova", "Nema podataka");
    sessionStorage.setItem("nazivUstanove", "Nema podataka");
    sessionStorage.setItem("polaznik", "Nema podataka");
    sessionStorage.setItem("maticniBroj", "Nema podataka");
    sessionStorage.setItem("premaObliku", "Nema podataka");
    sessionStorage.setItem("godinaUpisa", "Nema podataka");
    sessionStorage.setItem("redniBroj", "Nema podataka");
    sessionStorage.setItem("biljeskaPolaznika", "Nema podataka");
    sessionStorage.setItem("biljeskePrveGodine", "Nema podataka");
    sessionStorage.setItem("biljeskeDrugeGodine", "Nema podataka");
    sessionStorage.setItem("biljeskeTreceGodine", "Nema podataka");
    sessionStorage.setItem("biljeskeCetvrteGodine", "Nema podataka");
    sessionStorage.setItem("razredPregleda", "Nema podataka");
    sessionStorage.setItem("tekuciRazred", "Nema podataka");
  }
  
};

export const setUserOcjene = (ocjene) => {
  sessionStorage.setItem("ocjene", JSON.stringify(ocjene));
};

export const setUserIspiti = (ispiti) => {
  sessionStorage.setItem("ispiti", JSON.stringify(ispiti));
};

export const setUserIzostanci = (izostanci) => {
  sessionStorage.setItem("izostanci", JSON.stringify(izostanci));
};

export const removeUserSession = () => {
  sessionStorage.removeItem("token");
  sessionStorage.removeItem("data");
  sessionStorage.removeItem("osnovniPodaci");
  sessionStorage.removeItem("ustanova");
  sessionStorage.removeItem("nazivUstanove");
  sessionStorage.removeItem("polaznik");
  sessionStorage.removeItem("maticniBroj");
  sessionStorage.removeItem("premaObliku");
  sessionStorage.removeItem("godinaUpisa");
  sessionStorage.removeItem("redniBroj");
  sessionStorage.removeItem("biljeskaPolaznika");
  sessionStorage.removeItem("biljeskePrveGodine");
  sessionStorage.removeItem("biljeskeDrugeGodine");
  sessionStorage.removeItem("biljeskeTreceGodine");
  sessionStorage.removeItem("biljeskeCetvrteGodine");
  sessionStorage.removeItem("tekuciRazred");
  sessionStorage.removeItem("razredPregleda");
  sessionStorage.removeItem("ispiti");
  sessionStorage.removeItem("ocjene");
};
